<template>
  <div>
    <van-nav-bar :border="false"
                 title="消息详情"
                 left-arrow
                 @click-left="$router.back()"
    />
    <div class="page-message-wrap">
      <div class="title">{{ detailInfo.CreateTime }}</div>
      <div class="text">
        <p>{{ detailInfo.Item.Name }}</p>
        <p>{{ detailInfo.MsgContent }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      detailInfo: {
        Item: {
          Name: ''
        }
      }
    }
  },
  mounted() {
    this.WebGetProMsgInfo()
  },
  methods: {
    // 消息详情
    WebGetProMsgInfo() {
      let data = {
        PakeTypeNo: this.$route.params.sysno
      }
      this.$baseajax.normalJsonp(this.$base.baseEvent + '/WebGetProMsgInfo', data, res => {
        console.log(res);
        res = res.WebGetProMsgInfoResult
        if (res.ResponseCode == 1) {
          this.detailInfo = res.Item
        }
      }, err => {
      })
    }
  },
  beforeCreate() {
    document.querySelector('body').className = 'fff'
  },
  destroyed() {
    document.querySelector('body').className = ''
  },
}
</script>

<style lang="less" scoped>
.page-message-wrap {
  padding: .4rem 0.28rem;
  font-size: 0.34rem;
  line-height: 0.52rem;
  color: #666;

  .title {
    font-size: 0.26rem;
    color: #888888;
    text-align: center;
    margin-bottom: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home/MessageDetail.vue